import { ExperimentKey } from 'services/statsig/types';
import { useStatsig } from 'shared/hooks/statsig/useStatsig';

export const useDirectDepositGateway = () => {
  const { experimentSegmentActive } = useStatsig();

  const directDepositGatewayFlag = experimentSegmentActive(
    ExperimentKey.DD_SETUP_PAGE_EXPERIMENT,
    'Test',
  );
  const abCohort = directDepositGatewayFlag ? 'test' : 'control';

  return {
    directDepositGatewayFlag,
    abCohort,
  };
};

export default useDirectDepositGateway;
